export function formatSalary(min, max, currency) {
  if (!min && !max) return null;
  const fmt = (n) => (n >= 1000 ? `${Math.round(n / 1000)}k` : `${n}`);
  const c = currency || "";
  if (min && max) return `${fmt(min)}–${fmt(max)} ${c}`.trim();
  return `${fmt(min || max)} ${c}`.trim();
}

export function locationLabel(job) {
  const bits = [job.city, job.country].filter(Boolean);
  return bits.length ? bits.join(", ") : "Location not stated";
}

export function arrangementLabel(a) {
  if (!a) return "—";
  return a.charAt(0).toUpperCase() + a.slice(1);
}

export function titleCase(s) {
  if (!s) return "";
  return s.charAt(0).toUpperCase() + s.slice(1);
}
